import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ContaBancariaController from '../../../../controllers/ContaBancariaController';
import { toast } from 'react-toastify';
import { useLocation} from 'react-router-dom';

export default function ContaBancariaCadastrar() {
  const { userId } = useSelector((state: any) => state.Authentication);

  const history = createBrowserHistory();
  const [single, setSingle] = useState<any>(null);
  const { id } = useParams();
  const ContaBancariaId = id ? parseInt(id, 10) : null;
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (ContaBancariaId !== null && ContaBancariaId !== undefined) {
      getSingle(ContaBancariaId);
    }
  }, [ContaBancariaId]);

  const getSingle = async (ContaBancariaId: number) => {
    const Response = await ContaBancariaController.ListarUnico(ContaBancariaId);

    setSingle(Response.Data);
  };

  // Só existe UMA conta de emissão de boleto no sistema. Marcar esta como "Sim" quando já há
  // outra marcada é uma troca, e a API não grava nada sem o aval do usuário: devolve 200 com
  // { Gravado: false, ContaEmissaoAtual } em vez de 204. Aqui a gente pergunta usando esse
  // nome e, se confirmarem, reenvia tudo com ConfirmarTrocaEmissao = true.
  const gravar = async (values: any, confirmarTroca: boolean): Promise<any> => {
    const request = {
      ...values,
      ConfirmarTrocaEmissao: confirmarTroca,
      ...(ContaBancariaId === null ? {} : { ContaBancariaId }),
    };

    return ContaBancariaId === null
      ? ContaBancariaController.Adicionar(request)
      : ContaBancariaController.Atualizar(request);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    const inclusao = ContaBancariaId === null;
    const sucesso = inclusao
      ? 'Conta bancária incluída com sucesso!'
      : 'Conta bancária atualizado com sucesso!';
    const falha = inclusao
      ? 'Erro ao incluir a conta bancária!'
      : 'Erro ao atualizar a conta bancária!';

    // Desmarcar a conta de emissão deixa o sistema sem nenhuma, e aí nenhum boleto novo
    // pode ser gerado. Avisa antes, porque o efeito não é visível nesta tela.
    if (
      !inclusao &&
      single?.ctb_contaEmissaoBoleto === 'S' &&
      values.ContaEmissaoBoleto === 'N' &&
      !window.confirm(
        'Esta é a conta usada para emitir boletos. Marcando "Não", o sistema ficará SEM conta de emissão e nenhum boleto novo poderá ser gerado.\n\nDeseja continuar?'
      )
    ) {
      setSubmitting(false);
      return;
    }

    let response = await gravar(values, false);

    // 200 com Gravado = false: nada foi gravado, falta confirmar a troca.
    if (response.StatusCode === 200 && response.Data?.Gravado === false) {
      const atual = response.Data?.ContaEmissaoAtual;

      if (
        !window.confirm(
          `A conta "${atual}" está configurada hoje como conta de emissão de boleto.\n\nDeseja passar a emissão para esta conta? A conta "${atual}" deixará de emitir.`
        )
      ) {
        setSubmitting(false);
        return;
      }

      response = await gravar(values, true);
    }

    if (response.StatusCode === 204) {
      toast(sucesso, { type: 'success' });
      if (inclusao) resetForm();
    } else {
      toast(response.Message || falha, { type: 'error' });
      if (inclusao) resetForm();
    }

    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.ctb_descricao || '',
    Agencia: single?.ctb_agencia || '',
    DigitoAgencia: single?.ctb_agenciaDigito || '',
    Conta: single?.ctb_conta || '',
    DigitoConta: single?.ctb_contaDigito || '',
    CodigoContabil: single?.ctb_codigoContabil || '',
    CNAB: single?.ctb_CNAB || '',
    // [06/10] `??` e nao `||` nos campos NUMERICOS: em JavaScript 0 e falsy, entao
    // `0 || ''` da ''. As quatro contas cadastradas tem Nosso Numero preenchido (tres com
    // zero), e mesmo assim o campo aparecia vazio na tela - foi assim que isso apareceu.
    // Mesma armadilha do saldo de estoque no cadastro de produto.
    // Os campos de TEXTO abaixo seguem com `||`, onde nulo virar '' e o comportamento certo.
    NumeroRemessa: single?.ctb_numeroRemessa ?? '',
    NossoNumero: single?.ctb_nossoNumero ?? '',
    CodigoTransmissao: single?.ctb_codigoTransmissao || '',
    Carteira: single?.ctb_carteira || '',
    CodigoCedente: single?.ctb_codigoCedente || '',
    PrimeiraInstrucao: single?.ctb_primeiraInstrucao || '',
    SegundaInstrucao: single?.ctb_segundaInstrucao || '',
    TerceiraInstrucao: single?.ctb_terceiraInstrucao || '',
    TaxaJuros: single?.ctb_juros ?? '',
    PercentualMulta: single?.ctb_percentualMulta ?? '',
    // Código FEBRABAN: fonte única da instituição da conta, e é ele que decide a
    // integração na geração do boleto. Substituiu o antigo campo "Banco" (ban_id).
    CodigoBanco: single?.ctb_codigoBanco || '',
    ContaEmissaoBoleto: single?.ctb_contaEmissaoBoleto || 'N',
  };
  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatório!')
      .min(3, 'O Campo deve ter no mínimo 3 caracteres'),
    Agencia: Yup.string(),
    DigitoAgencia: Yup.string(),
    Conta: Yup.string(),
    DigitoConta: Yup.string(),
    CodigoContabil: Yup.string(),
    CNAB: Yup.string(),
    NumeroRemessa: Yup.string(),
    NossoNumero: Yup.string(),
    CodigoTransmissao: Yup.string(),
    Carteira: Yup.string(),
    CodigoCedente: Yup.string(),
    // 40 e o limite do Sicoob para cada linha de `mensagensInstrucao`. O maxLength do campo
    // ja impede digitar mais; isto pega o texto que chegar por outro caminho (colar, dados
    // antigos gravados quando o limite nao existia).
    PrimeiraInstrucao: Yup.string().max(40, 'Máximo de 40 caracteres'),
    SegundaInstrucao: Yup.string().max(40, 'Máximo de 40 caracteres'),
    TerceiraInstrucao: Yup.string().max(40, 'Máximo de 40 caracteres'),
    TaxaJuros: Yup.string(),
    PercentualMulta: Yup.string(),
    CodigoBanco: Yup.string()
      .matches(/^[0-9]{3}$/, 'Informe os 3 dígitos do banco (001 = Banco do Brasil, 756 = Sicoob)')
      .required('Campo Obrigatório!'),
    ContaEmissaoBoleto: Yup.string().oneOf(['S', 'N']).required('Campo Obrigatório!'),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE CONTA BANCÁRIA'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <BoxButtons>
              <Button
                variant='contained'
                onClick={() => history.back()}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>

            <fieldset disabled={duploClick}>
            <Field
              name='Descricao'
              as={TextField}
              label='Descrição'
              type='text'
              error={Boolean(errors?.Descricao)}
              helperText={errors?.Descricao}
            />
            <Field
              name='Agencia'
              as={TextField}
              label='Agência'
              type='text'
              error={Boolean(errors?.Agencia)}
              helperText={errors?.Agencia}
            />
            <Field
              name='DigitoAgencia'
              as={TextField}
              label='Dígito'
              type='text'
              error={Boolean(errors?.DigitoAgencia)}
              helperText={errors?.DigitoAgencia}
            />
            <Field
              name='Conta'
              as={TextField}
              label='Conta'
              type='text'
              error={Boolean(errors?.Conta)}
              helperText={errors?.Conta}
            />
            <Field
              name='DigitoConta'
              as={TextField}
              label='Dígito'
              type='text'
              error={Boolean(errors?.DigitoConta)}
              helperText={errors?.DigitoConta}
            />
            <Field
              name='CodigoContabil'
              as={TextField}
              label='Código Contábil'
              type='text'
              error={Boolean(errors?.CodigoContabil)}
              helperText={errors?.CodigoContabil}
            />
            <Field
              name='CNAB'
              as={TextField}
              label='Tipo Arquivo CNAB'
              type='text'
              error={Boolean(errors?.CNAB)}
              helperText={errors?.CNAB}
            />
            <Field
              name='NumeroRemessa'
              as={TextField}
              label='Número Remessa'
              type='text'
              error={Boolean(errors?.NumeroRemessa)}
              helperText={errors?.NumeroRemessa}
            />
            <Field
              name='NossoNumero'
              as={TextField}
              label='Nosso Número'
              type='text'
              error={Boolean(errors?.NossoNumero)}
              helperText={errors?.NossoNumero}
            />
            <Field
              name='CodigoTransmissao'
              as={TextField}
              label='Código Transmissão'
              type='text'
              error={Boolean(errors?.CodigoTransmissao)}
              helperText={errors?.CodigoTransmissao}
            />
            <Field
              name='Carteira'
              as={TextField}
              label='Carteira'
              type='text'
              error={Boolean(errors?.Carteira)}
              helperText={errors?.Carteira}
            />
            <Field
              name='CodigoCedente'
              as={TextField}
              label='Código Cedente'
              type='text'
              error={Boolean(errors?.CodigoCedente)}
              helperText={errors?.CodigoCedente}
            />
            {/* [SICOOB 30/09/2026] Estes tres campos ja existiam e nunca eram lidos por
                ninguem. Passaram a alimentar a caixa "Instrucoes (texto de responsabilidade
                do beneficiario)" do boleto Sicoob (`mensagensInstrucao`), por isso o limite
                de 40 caracteres: a coluna aceita 45, mas o Sicoob recusa acima de 40 - e
                recusa o boleto INTEIRO, de todas as parcelas da conta. A procedure corta em
                40 de qualquer forma; o maxLength existe para o usuario nao digitar um texto
                que vai sair pela metade sem ele saber. Linha em branco e simplesmente
                pulada, entao da para usar so a primeira e a terceira. */}
            <Field
              name='PrimeiraInstrucao'
              as={TextField}
              id='outlined-password-input'
              label='Primeira Instrução'
              type='text'
              inputProps={{ maxLength: 40 }}
              error={Boolean(errors?.PrimeiraInstrucao)}
              helperText={errors?.PrimeiraInstrucao || 'Sai na caixa Instruções do boleto (máx. 40 caracteres)'}
            />
            <Field
              name='SegundaInstrucao'
              as={TextField}
              //id="outlined-password-input"
              label='Segunda Instrução'
              type='text'
              inputProps={{ maxLength: 40 }}
              error={Boolean(errors?.SegundaInstrucao)}
              helperText={errors?.SegundaInstrucao || 'Máx. 40 caracteres'}
            />
            <Field
              name='TerceiraInstrucao'
              as={TextField}
              label='Terceira Instrução'
              type='text'
              inputProps={{ maxLength: 40 }}
              error={Boolean(errors?.TerceiraInstrucao)}
              helperText={errors?.TerceiraInstrucao || 'Máx. 40 caracteres'}
            />
            <Field
              name='TaxaJuros'
              as={TextField}
              id='outlined-password-input'
              label='Taxa de Juros'
              type='text'
              error={Boolean(errors?.TaxaJuros)}
              helperText={errors?.TaxaJuros}
            />
            <Field
              name='PercentualMulta'
              as={TextField}
              id='outlined-password-input'
              label='Percentual Multa'
              type='text'
              error={Boolean(errors?.PercentualMulta)}
              helperText={errors?.PercentualMulta}
            />
            <Field
              name='CodigoBanco'
              as={TextField}
              label='Código do Banco'
              type='text'
              inputProps={{ maxLength: 3 }}
              error={Boolean(errors?.CodigoBanco)}
              helperText={errors?.CodigoBanco || '001 = Banco do Brasil, 756 = Sicoob'}
            />
            <Field
              name='ContaEmissaoBoleto'
              as={TextField}
              select
              label='Conta Emissão Boleto'
              error={Boolean(errors?.ContaEmissaoBoleto)}
              helperText={
                errors?.ContaEmissaoBoleto ||
                'Apenas uma conta emite boletos por vez'
              }
            >
              <MenuItem value='S'>Sim</MenuItem>
              <MenuItem value='N'>Não</MenuItem>
            </Field>
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
